// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"405":"Weixin","463":"accountCenter"}[chunkId] || chunkId) + "." + {"405":"37870630","463":"185f1366","901":"1a564ed4"}[chunkId] + ".js";
};